import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ReactElement, ReactNode } from "react";

export function CompareMetric(props: {
  name: string;
  description: string;
  valueLeft?: number | undefined;
  valueRight?: number | undefined;
  unit?: string | null;
  format: boolean;
  children?: ReactNode;
}): ReactElement {
  return (
    <>
      <div className="text-gray-700">
        <Tippy content={props.description}>
          <span className="cursor-help">
            {props.name}{" "}
            {props.unit !== undefined && props.unit !== null
              ? `[${props.unit}]`
              : ""}
          </span>
        </Tippy>
      </div>
      <div className="text-right text-gray-500">
        {props.valueLeft !== undefined
          ? props.format
            ? props.valueLeft.toLocaleString("de-CH", {
                maximumFractionDigits: 2,
              })
            : props.valueLeft
          : ""}
      </div>
      <div className="text-right text-gray-500">
        {props.valueRight !== undefined
          ? props.format
            ? props.valueRight.toLocaleString("de-CH", {
                maximumFractionDigits: 2,
              })
            : props.valueRight
          : ""}
      </div>
      <div className="text-right text-gray-500">
        {props.valueLeft !== undefined && props.valueRight !== undefined
          ? props.format
            ? (props.valueRight - props.valueLeft).toLocaleString("de-CH", {
                maximumFractionDigits: 2,
              })
            : props.valueRight - props.valueLeft
          : ""}
      </div>
      {props.children}
    </>
  );
}
